import classNames from 'classnames';

import NotInterested from '@/assets/icons/md_not_interested.svg?component';
import TrendingDown from '@/assets/icons/md_trending_down.svg?component';
import TrendingFlat from '@/assets/icons/md_trending_flat.svg?component';
import TrendingUp from '@/assets/icons/md_trending_up.svg?component';
import { type IconComponent, SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

import styles from './TrendIcon.module.scss';

export interface TrendIconProps {
    disabled: boolean;
    direction: 'up' | 'down' | 'flat';
    status?: 'negative' | 'positive' | 'neutral';
    size?: number;
}

const DIRECTION_ICONS: Record<TrendIconProps['direction'], IconComponent> = {
    up: TrendingUp,
    down: TrendingDown,
    flat: TrendingFlat,
};

function TrendIcon({ disabled, status, direction, size }: TrendIconProps) {
    return (
        <SvgIcon
            icon={disabled ? NotInterested : DIRECTION_ICONS[direction]}
            size={size === undefined ? 'inherit' : 'custom'}
            customSize={size}
            className={classNames(styles.trendicon, status && styles[status])}
        />
    );
}

export default TrendIcon;
export { TrendIcon };
